import { useEffect, useState } from 'react';

// Module-scoped cache. Lives across mounts in the same SPA session so a second
// open of NicheDetail doesn't re-fetch the topojson. Promise is cached too so
// concurrent mounts share the same in-flight request.
let cached = null;
let inFlight = null;

const ATLAS_URL = 'https://unpkg.com/world-atlas@2.0.2/countries-110m.json';

export function useWorldAtlas() {
  const [topo, setTopo] = useState(cached);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) return;

    let cancelled = false;
    if (!inFlight) {
      inFlight = fetch(ATLAS_URL)
        .then((r) => {
          if (!r.ok) throw new Error(`world-atlas ${r.status}`);
          return r.json();
        })
        .then((json) => {
          cached = json;
          inFlight = null;
          return json;
        })
        .catch((e) => {
          inFlight = null;
          throw e;
        });
    }

    inFlight
      .then((json) => { if (!cancelled) { setTopo(json); setLoading(false); } })
      .catch((e) => { if (!cancelled) { setError(e); setLoading(false); } });

    return () => { cancelled = true; };
  }, []);

  return { topo, loading, error };
}
